module.exports = __webpack_public_path__ + "img/132-fcf6eb.png";